/** Premium users never see internal affiliate ads. */
export const ADS_ELIGIBILITY_EVENT = 'poppyruz:ads-eligibility';

export function isPremiumUser() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem('is_premium') === '1';
}

export function shouldShowAds() {
  return !isPremiumUser();
}

/** Call after writing `is_premium` so same-tab UI can hide ads immediately. */
export function notifyAdsEligibilityChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(ADS_ELIGIBILITY_EVENT));
}
